import React from 'react';

export const ScrollToZoom = () => (
    <>
        <rect x='6' y='3' width='12' height='18' rx='4' />
        <line x1='12' y1='7' x2='12' y2='11' />
    </>
);